// extracted by mini-css-extract-plugin
export default {"icon_wrapper":"Administration_icon_wrapper__n4bcv","shimmer":"Administration_shimmer__JZ0FH"};